import { CommonModule } from '@angular/common'
import { Component, OnInit, ViewChild, computed, inject, model, signal } from '@angular/core'
import { NgbActiveOffcanvas, NgbNavModule } from '@ng-bootstrap/ng-bootstrap'
import { ButtonComponent } from '../../form-elements/button/button.component'
import { AppStore } from 'src/app/core/app.store'
import { StaffDetailComponent } from '../staff-detail/staff-detail.component'
import { Observable, tap } from 'rxjs'
import { MobileTracking } from 'src/app/shared/interfaces/mobile-tracking/mobile-tracking.interface'
import { MobileTrackingService } from 'src/app/core/services/mobile-tracking.service'
import { GoogleMap, GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps'
import { HttpClient } from '@angular/common/http'
import { StaffRole } from 'src/app/shared/interfaces/staff/staff-role.interface'
import { FormBuilder, ReactiveFormsModule } from '@angular/forms'
import { InputComponent } from '../../form-elements/input/input.component'
import { toSignal } from '@angular/core/rxjs-interop'
import { t } from '@fullcalendar/resource/internal-common'

interface MapMarkerWithOptions {
    position: google.maps.LatLngLiteral
    marker: google.maps.marker.AdvancedMarkerElement
}

@Component({
    selector: 'sf-staff-pullout',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        GoogleMapsModule,
        NgbNavModule,
        InputComponent,
        ButtonComponent,
        StaffDetailComponent,
    ],
    templateUrl: './staff-pullout.component.html',
    styleUrl: './staff-pullout.component.scss',
})
export class StaffPulloutComponent implements OnInit {
    activeOffcanvas = inject(NgbActiveOffcanvas)
    appStore = inject(AppStore)
    mobileTrackingService = inject(MobileTrackingService)

    #fb = inject(FormBuilder)

    search = this.#fb.control<string | null>(null)
    searchTerm = toSignal(this.search.valueChanges, { initialValue: null })
    searchPlaceholder = computed(() => {
        const count = this.staff().length
        return count === 1 ? 'Search 1 staff member' : `Search ${count} staff members`
    })

    staff = this.appStore.staff
    filteredStaff = computed(() => {
        const term = this.searchTerm()?.toLowerCase().trim()
        if (!term) {
            return this.staff()
        }
        return this.staff().filter((s) => s.fullName.toLowerCase().includes(term))
    })

    @ViewChild(GoogleMap) map!: google.maps.Map
    @ViewChild(MapInfoWindow) infoWindow!: MapInfoWindow
    center: google.maps.LatLngLiteral = { lat: 52, lng: 1 }
    zoom = 8
    markers: MapMarkerWithOptions[] = []

    markerOptions: google.maps.MarkerOptions = { draggable: false }
    markerPositions: google.maps.LatLngLiteral[] = []
    bounds!: google.maps.LatLngBounds

    staffTracks$!: Observable<MobileTracking[]>
    tracks: MobileTracking[] = []

    userRoles = signal<StaffRole[]>([])

    ngOnInit(): void {
        this.loadTracks()
    }

    loadTracks() {
        this.bounds = new google.maps.LatLngBounds()

        this.staffTracks$ = this.mobileTrackingService.getLatestStaffLocations().pipe(
            tap((tracks) => {
                this.tracks = tracks
                this.markerPositions = tracks.map((track) => {
                    this.bounds.extend({ lat: track.latitude, lng: track.longitude })
                    return { lat: track.latitude, lng: track.longitude }
                })

                this.markers = tracks.map((track) => {
                    const pinBackground = new google.maps.marker.PinElement({
                        background: '#FBBC04',
                    })
                    return {
                        position: { lat: track.latitude, lng: track.longitude },
                        marker: new google.maps.marker.AdvancedMarkerElement({
                            gmpDraggable: false,
                            title: track.user.fullName,
                            content: pinBackground.element,
                        }),
                    } as MapMarkerWithOptions
                })

                setTimeout(() => {
                    this.map?.fitBounds(this.bounds, {
                        bottom: 50,
                        left: 50,
                        right: 50,
                        top: 50,
                    })
                }, 1)
            })
        )
    }

    openInfoWindow(marker: MapMarkerWithOptions): void {
        console.log(marker.marker.title)
        // const track = this.tracks.find((x) => x.fullname === marker.marker.title)
        // if (track) {
        //     this.infoWindow.options = {
        //         minWidth: 300,
        //         content: `<p><strong>${track.fullname}</strong></p>`,
        //     }
        //     this.infoWindow.openAdvancedMarkerElement(marker.marker)
        // }
    }

    dismiss(): void {
        this.activeOffcanvas.dismiss()
    }
    close(): void {
        this.activeOffcanvas.close()
    }
}
